<span class="nav-breadcrumb" *ngIf="text">
    <mat-icon>chevron_right</mat-icon>
    <span *ngIf="!navigable" [innerHtml]="text"></span>
    <a [routerLink]="routerLink" *ngIf="navigable">
        <span [innerHtml]="text"></span>
    </a>
</span>
